import { render, staticRenderFns } from "./ProjectsForm.vue?vue&type=template&id=7de6a8d1&scoped=true&"
import script from "./ProjectsForm.vue?vue&type=script&lang=js&"
export * from "./ProjectsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsForm.vue?vue&type=style&index=0&id=7de6a8d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de6a8d1",
  null
  
)

export default component.exports